import * as d3 from "d3";
import { useD3 } from "../Hooks/useD3";
import { Stack } from "react-bootstrap";
import { zoom } from "d3-zoom";
import ColorScale from "./Legend";
import indiaDistricts from "./indiadistricts.json";
import useMediaQuery from "@mui/material/useMediaQuery";

function titleCase(string) {
  if (string.split(" ").length === 2) {
    return (
      string
        .split(" ")[0]
        .charAt(0)
        .toUpperCase() +
      string.split(" ")[0].slice(1) +
      " " +
      string
        .split(" ")[1]
        .charAt(0)
        .toUpperCase() +
      string.split(" ")[1].slice(1)
    );
  } else {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}

function Heatmap({ data, showHeatwave }) {
  const matches = useMediaQuery("(max-width: 458px)");
  const tablet = useMediaQuery("(max-width: 768px)");
  const ref = useD3((svg) => {
    svg.selectAll("*").remove();
    const width = matches ? 350 : tablet ? 525 : 700;
    const height = matches ? 350 : tablet ? 525 : 700;

    const zoom = d3
      .zoom()
      .scaleExtent([0.75, 8])
      .on("zoom", function(event) {
        svg.attr("transform", event.transform);
      });

    const projection = d3
      .geoMercator()
      .center([82, 23.1])
      .scale(matches ? 525 : tablet ? 787.5 : 1050)
      .translate([width / 2, height / 2]);

    const projection2 = d3
      .geoMercator()
      .center([81.5, 23.5])
      .scale(matches ? 537.5 : tablet ? 806.25 : 1075)
      .translate([width / 2, height / 2]);

    const colorScale = d3
      .scaleSequential(
        d3.interpolateRgbBasis([
          "#00008f",
          "#0000ff",
          "#0080ff",
          "#00ffff",
          "#80ff00",
          "#ffff00",
          "#ff8000",
          "#ff0000",
          "#800000",
        ])
      )
      .domain([15, 45]);

    // const greenScale = d3
    //   .scaleLinear()
    //   .domain([-15, 40])
    //   .range(["fill", "#9BEA7A"]);

    const orangeScale = d3
      .scaleLinear()
      .domain([40, 45])
      .range(["fill", "#F6C73E"]);

    const redScale = d3
      .scaleLinear()
      .domain([45, 60])
      .range(["fill", "#FF7D06"]);

    const pathGenerator = d3.geoPath().projection(projection2);

    var plot = svg
      .selectAll("g")
      .data(data)
      .join("g");

    plot
      .append("rect")
      .attr("width", matches ? 10.5 : tablet ? 15.75 : 21)
      .attr("height", matches ? 10.5 : tablet ? 15.75 : 21)
      .attr("x", (d) => projection([d.Longitude, d.Latitude])[0])
      .attr("y", (d) => projection([d.Longitude, d.Latitude])[1])
      .attr("rx", 2)
      .attr("ry", 2)
      .style("filter", "url(#background-blur)")
      .style("fill", function(d) {
        if (d.Heatwave === 1) {
          return redScale(d.Temperature);
        } else if (d.Heatwave === 0) {
          return orangeScale(d.Temperature);
        } else {
          return "transparent";
        }
      });
    // .style("opacity", function(d) {
    //   if (!showHeatwave) {
    //     return 1;
    //   } else {
    //     return (d.Temperature >= 40 && d.Temperature <= 45) ||
    //       d.Temperature > 45
    //       ? 1
    //       : 0;
    //   }
    // });

    var border = svg
      .append("path")
      .datum(indiaDistricts)
      .attr("d", pathGenerator)
      .style("stroke", "#212121")
      .style("fill", "none")
      .style("stroke-width", "0.5px");

    svg.call(zoom);

    plot
      .append("title")
      .text(
        (d) =>
          `District: ${titleCase(d.District)}\nRegion: ${titleCase(
            d.Region
          )}\nTemperature: ${d.Temperature.toFixed(2)}°C`
      );

    return svg.node();
  });

  return (
    <Stack direction="horizontal" gap={4} className="svgContainer">
      <svg
        ref={ref}
        id="svg"
        style={{
          height: matches ? 100 : tablet ? 350 : 700,
          width: matches ? 100 : tablet ? 350 : 700,
        }}
      ></svg>
      {/* <ColorScale /> */}
    </Stack>
  );
}

export default Heatmap;
